import { RouteConstants } from '../../constants/RouteConstants';
import { getLoggedInOrgName } from '../../util/admin-utils';

const orgName = getLoggedInOrgName();

interface URLPath {
  key: string;
  label: string;
}

const urlPaths: URLPath[] = [];

export default urlPaths;
